import React from "react";
import classes from "./SortingCard.module.scss";
const SortingCard = (props) => {
  const { product, color, categoryName } = props;
  return (
    <div className={classes.container} style={{ color: color }}>
      <div className={classes.idIn}>
        {product.idin} {categoryName}
      </div>
      <div className={classes.name}>{product.name}</div>
    </div>
  );
};

export default SortingCard;
